<!-- ChatbotMessageComponent — Renderiza un mensaje individual del chatbot -->
<!-- Req 5.4, 5.5, 5.7, 5.8 -->

<div
  class="chatbot-msg"
  [class.chatbot-msg--user]="isUser"
  [class.chatbot-msg--assistant]="isAssistant"
  [attr.aria-label]="isUser ? 'Mensaje del usuario' : 'Respuesta del asistente'"
  role="article"
>

  <!-- =========================================================
       Avatar / icono del emisor
       ========================================================= -->
  <div class="chatbot-msg__avatar" aria-hidden="true">
    <i
      class="bi"
      [class.bi-person-fill]="isUser"
      [class.bi-robot]="isAssistant"
    ></i>
  </div>

  <!-- =========================================================
       Burbuja de mensaje
       ========================================================= -->
  <div class="chatbot-msg__bubble">

    <!-- Indicador de escritura: tres puntos animados
         Visible cuando el asistente está en streaming y aún no hay contenido.
         Req 5.5 -->
    <div
      *ngIf="showTypingIndicator"
      class="chatbot-msg__typing"
      aria-label="El asistente está escribiendo..."
      role="status"
    >
      <span class="chatbot-msg__typing-dot"></span>
      <span class="chatbot-msg__typing-dot"></span>
      <span class="chatbot-msg__typing-dot"></span>
    </div>

    <!-- Contenido del mensaje (texto acumulado de tokens o mensaje completo).
         Req 5.4: renderizado progresivo de tokens. -->

    <!-- Mensajes del usuario: texto plano -->
    <span
      *ngIf="message?.content && isUser"
      class="chatbot-msg__content"
    >{{ message.content }}</span>

    <!-- Mensajes del asistente: renderiza markdown (negritas, títulos, tablas) -->
    <div
      *ngIf="message?.content && isAssistant"
      class="chatbot-msg__content chatbot-msg__content--rich"
      [innerHTML]="message.content | boldMarkdown"
    ></div>
    <span
        *ngIf="showStreamingCursor"
        class="chatbot-msg__cursor"
        aria-hidden="true"
      ></span>

    <!-- Marca de tiempo — se muestra si está disponible -->
    <span
      *ngIf="formattedTimestamp"
      class="chatbot-msg__timestamp"
      [attr.aria-label]="'Enviado a las ' + formattedTimestamp"
    >{{ formattedTimestamp }}</span>

  </div>

</div>
